import {
  ADD_DISCOUNT,
  ADD_DISCOUNT_FULFILLED,
  ADD_DISCOUNT_REJECTED,
  CLEAR_DISCOUNTS,
  CLEAR_DISCOUNTS_FULFILLED,
  CLEAR_DISCOUNTS_REJECTED,
  FETCH_DISCOUNTS,
  FETCH_DISCOUNTS_FULFILLED,
  FETCH_DISCOUNTS_REJECTED,
  REMOVE_DISCOUNT,
  REMOVE_DISCOUNT_FULFILLED,
  REMOVE_DISCOUNT_REJECTED,
  REMOVE_DISCOUNTS,
  REMOVE_DISCOUNTS_FULFILLED,
  REMOVE_DISCOUNTS_REJECTED,
  SUBMIT_DISCOUNTS,
  SUBMIT_DISCOUNTS_FULFILLED,
  SUBMIT_DISCOUNTS_REJECTED,
  RESET_DISCOUNTS,
  RESET_REMOVE_DISCOUNTS,
} from './types';

const initialState = {
  availableDiscounts: [],
  appliedDiscounts: [],
  discountsNotApplied: [],
  unavailableDiscounts: [],
  updatedDiscounts: [],
  fetchDiscountsState: {
    success: undefined,
    isPending: false,
    error: undefined,
  },
  addDiscountState: {
    isPending: false,
    error: undefined,
  },
  removeDiscountState: {
    isPending: false,
    error: undefined,
  },
  removeDiscountsState: {
    isPending: false,
    success: undefined,
    error: undefined,
  },
  clearDiscountsState: {
    isPending: false,
    error: undefined,
  },
  submitDiscountsState: {
    isPending: false,
    success: undefined,
    receiptText: undefined,
    error: undefined,
  },
};

export function discountsReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_DISCOUNT: {
      return {
        ...state,
        addDiscountState: {
          isPending: true,
          error: undefined,
        },
      };
    }

    case ADD_DISCOUNT_FULFILLED: {
      return {
        ...state,
        addDiscountState: {
          ...state.addDiscountState,
          isPending: false,
        },
      };
    }

    case ADD_DISCOUNT_REJECTED: {
      return {
        ...state,
        addDiscountState: {
          isPending: false,
          error: action.payload.error,
        },
      };
    }

    case CLEAR_DISCOUNTS: {
      return {
        ...state,
        clearDiscountsState: {
          isPending: true,
          error: undefined,
        },
      };
    }

    case CLEAR_DISCOUNTS_FULFILLED: {
      return {
        ...state,
        addDiscountState: {
          isPending: false,
          error: undefined,
        },
        removeDiscountState: {
          isPending: false,
          error: undefined,
        },
        clearDiscountsState: {
          isPending: false,
        },
      };
    }

    case CLEAR_DISCOUNTS_REJECTED: {
      return {
        ...state,
        clearDiscountsState: {
          isPending: false,
          error: action.payload.error,
        },
      };
    }

    case FETCH_DISCOUNTS: {
      return {
        ...state,
        fetchDiscountsState: {
          success: undefined,
          isPending: true,
          error: undefined,
        },
      };
    }

    case FETCH_DISCOUNTS_FULFILLED: {
      return {
        ...state,
        fetchDiscountsState: {
          ...state.fetchDiscountsState,
          success: true,
          isPending: false,
        },
        availableDiscounts: action.payload.availableDiscounts,
        appliedDiscounts: action.payload.appliedDiscounts,
        discountsNotApplied: action.payload.discountsNotApplied,
        unavailableDiscounts: action.payload.unavailableDiscounts,
        updatedDiscounts: action.payload.updatedDiscounts,
      };
    }

    case FETCH_DISCOUNTS_REJECTED: {
      return {
        ...state,
        fetchDiscountsState: {
          success: false,
          isPending: false,
          error: action.payload.error,
        },
      };
    }

    case REMOVE_DISCOUNT: {
      return {
        ...state,
        removeDiscountState: {
          isPending: true,
          error: undefined,
        },
      };
    }

    case REMOVE_DISCOUNT_FULFILLED: {
      return {
        ...state,
        removeDiscountState: {
          ...state.removeDiscountState,
          isPending: false,
        },
      };
    }

    case REMOVE_DISCOUNT_REJECTED: {
      return {
        ...state,
        removeDiscountState: {
          isPending: false,
          error: action.payload.error,
        },
      };
    }

    case REMOVE_DISCOUNTS: {
      return {
        ...state,
        removeDiscountsState: {
          ...state.removeDiscountState,
          isPending: true,
          success: undefined,
          error: undefined,
        },
      };
    }

    case REMOVE_DISCOUNTS_FULFILLED: {
      return {
        ...state,
        removeDiscountsState: {
          ...state.removeDiscountState,
          success: true,
          isPending: false,
        },
      };
    }

    case REMOVE_DISCOUNTS_REJECTED: {
      return {
        ...state,
        removeDiscountsState: {
          ...state.removeDiscountState,
          isPending: false,
          success: false,
          error: action.payload.error,
        },
      };
    }

    case RESET_REMOVE_DISCOUNTS: {
      return {
        ...state,
        removeDiscountsState: {
          ...initialState.removeDiscountsState,
        },
      };
    }

    case RESET_DISCOUNTS: {
      return {
        ...initialState,
      };
    }

    case SUBMIT_DISCOUNTS: {
      return {
        ...state,
        submitDiscountsState: {
          isPending: true,
          success: undefined,
          receiptText: undefined,
          error: undefined,
        },
      };
    }

    case SUBMIT_DISCOUNTS_FULFILLED: {
      return {
        ...state,
        submitDiscountsState: {
          isPending: false,
          success: true,
          receiptText: action.payload.receiptText, // TODO (keithwong) hook up receipt logic
          error: undefined,
        },
      };
    }

    case SUBMIT_DISCOUNTS_REJECTED: {
      return {
        ...state,
        submitDiscountsState: {
          isPending: false,
          success: false,
          receiptText: undefined,
          error: action.payload.error,
        },
      };
    }

    default:
      return state;
  }
}
